import React, { useState } from "react";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Box from "@material-ui/core/Box";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../assets/css/login.css";
import Loading from "../spinner/spinner";
import PropTypes from "prop-types"

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const useStyles = makeStyles((theme: any) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%",
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));
type LoginResult =
  | { ok: true; token: string }
  | { ok: false; message: string };

async function loginUser(credentials: {
  username?: string;
  password?: string;
}): Promise<LoginResult> {
  let res: Response;
  try {
    res = await fetch(
      `${process.env.REACT_APP_API_URL}/api/login`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(credentials),
      }
    );
  } catch {
    return {
      ok: false,
      message:
        "Connexion impossible (réseau ou accès bloqué par le navigateur / CORS).",
    };
  }
  if (!res.ok) {
    return {
      ok: false,
      message: "Identifiant ou mot de passe incorrect.",
    };
  }
  try {
    const data = await res.json();
    if (data?.token) {
      return { ok: true, token: data.token };
    }
    return {
      ok: false,
      message: "Réponse serveur invalide (token manquant).",
    };
  } catch {
    return {
      ok: false,
      message: "Réponse serveur invalide.",
    };
  }
}

const SignIn = (props: any) => {
  const [username, setUserName] = useState<string>();
  const [password, setPassword] = useState<string>();
  const classes = useStyles();
  const [isLoaded, setIsLoading] = useState<Boolean>(false);
  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const result = await loginUser({ username, password });
      if (result.ok) {
        props.setToken(result.token);
      } else {
        toast.error(result.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
        });
      }
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <Container component="main" maxWidth="xs">
      <ToastContainer />
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          S identifier
        </Typography>
        <form className={classes.form}  onSubmit={(e) => handleSubmit(e)}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="username"
            label="Nom d'utilisateur"
            name="username"
            autoComplete="username"
            autoFocus
            onChange={(e) => setUserName(e.target.value)}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label="Mot de passe"
            type="password"
            id="password"
            autoComplete="current-password"
            onChange={(e) => setPassword(e.target.value)}
          />
          {isLoaded ? (
            <Loading />
          ) : (
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
             
            >
              Valider
            </Button>
          )}
        </form>
      </div>
      <Box mt={8}>
        <Copyright />
      </Box>
    </Container>
  );
};
SignIn.propTypes = {
  setToken: PropTypes.func.isRequired,
};
export default SignIn;
